import contractCreateComponent from './contract.create.component';
import './contract.create.scss'

let contractCreateModule = angular.module('contractcreate', [
  ])

  .component('contractcreate', contractCreateComponent)

  .name;

export default contractCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/create/index.js